import "./about/web-kiosk-about";
import "./home/web-kiosk-home";
import "./feedback/web-kiosk-feedback";
import "./privacy/web-kiosk-privacy";
import "./video/web-kiosk-video";
import "./services/web-kiosk-services";
import "./information-and-hours/web-kiosk-information-and-hours";
import "./connectedDevices/web-kiosk-connected-device";
import "./connectedDevices/web-kiosk-connected-devices";
import "./scheduleAppointments/web-kiosk-schedule-appointments";
import "./new-session/web-kiosk-new-session";
import "./virtual-care/web-kiosk-virtual-care";

export const pages = [
  {
    path: "home",
    component: "web-kiosk-home",
    key: "home",
  },
  {
    path: "new-session",
    component: "web-kiosk-new-session",
    key: "newSession",
  },
  { path: "about", component: "web-kiosk-about", key: "about" },
  { path: "services", component: "web-kiosk-services", key: "services" },
  { path: "video", component: "web-kiosk-video", key: "video" },
  { path: "feedback", component: "web-kiosk-feedback", key: "feedback" },
  { path: "privacy", component: "web-kiosk-privacy", key: "privacy" },
  {
    path: "informationAndHours",
    component: "web-kiosk-information-and-hours",
    key: "informationAndHours",
  },
  {
    path: "connectedDevices",
    component: "web-kiosk-connected-devices",
    key: "connectedDevices",
  },
  {
    path: "connectedDevice",
    component: "web-kiosk-connected-device",
    key: "connectedDevices",
  },
  {
    path: "scheduleAppointments",
    component: "web-kiosk-schedule-appointments",
    key: "scheduleAppointments",
  },
  {
    path: "virtual-care",
    component: "web-kiosk-virtual-care",
    key: "virtualCare",
  },
];
